import { useState } from "react"

import useAppHotkey from "@hooks/useAppHotkey"
import useCreateMenuItems from "@hooks/useCreateMenuItems"

import { faIcon } from "@utils/faIcon"

import { Menu } from "@organisms"
import NavSidebarItem from "@organisms/NavSidebar/components/NavSidebarItem/NavSidebarItem"

// TODO: Re-enable create new job series CTA
// import JobSeriesCreateDialog from "@pages/JobSeries/JobSeriesCreateDialog/JobSeriesCreateDialog"
import styles from "./NavSidebarCreateButton.module.scss"
import { NavSidebarCreateButtonProps } from "./NavSidebarCreateButton.types"

const OPEN_OVERFLOW_MENU_HOTKEY = "c"

export default function NavSidebarCreateButton(props: NavSidebarCreateButtonProps) {
    const {
        _isFocused = false,
        _isHovered = false,
        isPressed = false,
        isDisabled = false,
        defaultOpen = false,
    } = props

    const [isOpen, setIsOpen] = useState<boolean>(defaultOpen)
    // TODO: Re-enable create new job series CTA
    // const [isSeriesDialogOpen, setIsSeriesDialogOpen] = useState<boolean>(false)

    const toggleMenu = () => setIsOpen(!isOpen)

    useAppHotkey(
        OPEN_OVERFLOW_MENU_HOTKEY,
        () => {
            if (!isDisabled) {
                toggleMenu()
            }
        },
        {
            enabled: !isDisabled,
        },
        [isDisabled],
    )

    const menuContentItems = useCreateMenuItems(styles.subMenu)

    return (
        <>
            <Menu
                title="Create"
                className={styles.menu}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                popoverSide="right"
                popoverAlign="start"
                trigger={
                    <NavSidebarItem
                        label="Create"
                        icon={faIcon({ name: "circle-plus", style: "solid" })}
                        isEmphasized={true}
                        isDisabled={isDisabled}
                        _isFocused={_isFocused}
                        _isHovered={_isHovered}
                        isPressed={isPressed || isOpen}
                        onClick={toggleMenu}
                        modifier="hotkey"
                        symbolName="C"
                    />
                }
                items={[{ type: "group", items: menuContentItems }]}
            />
            {/* TODO: Re-enable create new job series CTA
            <JobSeriesCreateDialog isOpen={isSeriesDialogOpen} onOpenChange={setIsSeriesDialogOpen} />
            */}
        </>
    )
}
